import { render, staticRenderFns } from "./LocationCard.vue?vue&type=template&id=f52805d2&"
import script from "./LocationCard.vue?vue&type=script&lang=js&"
export * from "./LocationCard.vue?vue&type=script&lang=js&"
import style0 from "./LocationCard.vue?vue&type=style&index=0&id=f52805d2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports